import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  editLineDiscount,
  editLineQuantity,
  getOrderDetail,
  removeLine,
  setOrderFulfillingBranch,
} from "../../actions/orders/orders";
import { update_page_meta } from "../../actions/page/header";
import { connect } from "react-redux";
import PageHeader from "../../components/page/PageHeader";
import ClicktoEditInput from "../../components/ClicktoEditInput";
import { formatCurrency } from "../../utils/formatCurrency";
import { HomePageURL } from "../../assets/const";
import { FullAddressWithName } from "../../components/fullAddresswithName";
import BootstrapModal from "../../components/customBootstrapModal";
import BranchSelector from "../../components/branchSelector";

const OrderLine = ({ line, order, setOrder }) => {
  const [quantityUpdating, setQuantityUpdating] = useState(false);
  const [discountUpdating, setDiscountUpdating] = useState(false);
  const handleEditLineQuantity = async (quantity) => {
    if (!quantity || quantityUpdating) {
      return;
    }
    setQuantityUpdating(true);
    let res = await editLineQuantity(order?.id, line?.id, quantity);
    if (res.success) {
      let lineItems = order.lineItems;
      // Find the index of the line in lineItems with its id
      const index = lineItems.findIndex((item) => item?.id === line?.id);

      if (index !== -1) {
        // Update the line quantity and replace the old line in the array
        lineItems[index].quantity = parseInt(quantity);
      }

      let amountPayable = 0;
      lineItems.forEach((l) => {
        amountPayable +=
          l?.product?.salePrice * l?.quantity -
          (l?.product?.salePrice * l?.quantity * l?.discount) / 100;
      });

      setOrder((prevOrder) => ({
        ...prevOrder,
        amount_payable: amountPayable,
        lineItems: lineItems,
      }));
    }
    setQuantityUpdating(false);
  };
  const handleEditLineDiscount = async (discount) => {
    if (isNaN(parseFloat(discount)) || discountUpdating) {
      return;
    }
    setDiscountUpdating(true);
    const res = await editLineDiscount(order?.id, line?.id, discount);
    if (res.success) {
      let lineItems = order.lineItems;
      // Find the index of the line in lineItems with its id
      const index = lineItems.findIndex((item) => item?.id === line?.id);

      if (index !== -1) {
        // Update the line quantity and replace the old line in the array
        lineItems[index].discount = parseInt(discount);
      }

      let amountPayable = 0;
      lineItems.forEach((l) => {
        amountPayable +=
          l?.product?.salePrice * l?.quantity -
          (l?.product?.salePrice * l?.quantity * l?.discount) / 100;
      });

      setOrder((prevOrder) => ({
        ...prevOrder,
        amount_payable: amountPayable,
        lineItems: lineItems,
      }));
    }
    setDiscountUpdating(false);
  };
  const handleRemoveLine = async () => {
    if (
      !window.confirm(
        "You are about to remove a product from the order. This will affect the order price. Are you sure?"
      )
    )
      return;
    let res = await removeLine(order?.id, line?.id);
    if (res.success) {
      let lineItems = order.lineItems.filter((item) => item?.id !== line?.id);
      let amountPayable = 0;
      lineItems.forEach((l) => {
        amountPayable +=
          l?.product?.salePrice * l?.quantity -
          (l?.product?.salePrice * l?.quantity * l?.discount) / 100;
      });
      setOrder((prevOrder) => ({
        ...prevOrder,
        amount_payable: amountPayable,
        lineItems: lineItems,
      }));
    }
  };
  return (
    <tr key={line?.id}>
      <td></td>
      <td>{line?.product?.display_name}</td>
      <td>{formatCurrency(line?.product?.salePrice)}</td>
      <td>
        <ClicktoEditInput
          placeholder={line?.quantity}
          handleChange={handleEditLineQuantity}
        />
      </td>
      <td>{formatCurrency(line?.product?.salePrice * line?.quantity)}</td>
      <td>
        <ClicktoEditInput
          placeholder={line?.discount}
          handleChange={handleEditLineDiscount}
        />
      </td>
      <td>
        {formatCurrency(
          line?.product?.salePrice * line?.quantity -
            line?.product?.salePrice * line?.quantity * (line?.discount / 100)
        )}
      </td>
      <td style={{ height: "100%" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <span
            role="button"
            onClick={handleRemoveLine}
            style={{ display: "flex", height: "18px", width: "18px" }}
            title="Remove Line"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="red"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-trash-2"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </span>
        </div>
      </td>
    </tr>
  );
};

const OrderDetail = ({ update_page_meta }) => {
  const { orderId } = useParams();
  const isNumeric = /^[0-9]+$/.test(orderId);
  const [order, setOrder] = useState(null);
  const [branchSelectorShow, setBranchSelectorShow] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  useEffect(() => {
    if (!isNumeric) return;
    const fetch = async () => {
      let res = await getOrderDetail(orderId);
      if (res.success) {
        setOrder(res.order);
      }
    };
    fetch();
  }, [orderId]);
  useEffect(() => {
    if (order?.order_no)
      update_page_meta({
        title: `${order?.order_no} | Order`,
        description: `Details of ${order?.order_no}`,
      });
    if (order?.branch_address && order.branch_address?.id) {
      setSelectedBranch(order?.branch_address);
    }
  }, [order, update_page_meta]);
  const handleSetBranch = async () => {
    if (selectedBranch?.id === order?.branch_address?.id) return;
    if (!selectedBranch) {
      alert("Please select a branch to fulfill this order.");
      return;
    }
    let res = await setOrderFulfillingBranch(order?.id, selectedBranch?.id);
    if (res.success) {
      alert(`Successfully set branch to ${selectedBranch?.name}`);
      setOrder((prevOrder) => ({
        ...prevOrder,
        branch_address: selectedBranch?.address,
      }));
    } else {
      alert(`Failed to set branch: ${res.detail}`);
    }
  };
  console.log("Order Detail", JSON.stringify(order));
  useEffect(() => {
    if (selectedBranch) {
      handleSetBranch();
    }
  }, [selectedBranch]);
  if (!isNumeric) {
    return null;
  }

  return (
    <>
      <PageHeader title={order?.order_no} />

      {/* <div class="row layout-top-spacing" id="cancel-row">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                    <button class="btn btn-primary mb-2 me-2" onClick={() => navigate(`${HomePageURL}/stores/visits/?store=${Store?.slug}`, {replace: false})}>
                        Registered Visits
                    </button>
                    <button class="btn btn-primary mb-2 me-2" onClick={() => navigate(`${HomePageURL}/stores/orders/?store=${Store?.slug}`, {replace: false})}>
                        View Orders
                    </button>
                </div>
            </div> */}

      <div className="row layout-top-spacing" id="cancel-row">
        <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <a
            class="btn btn-primary mb-2 me-2"
            rel="no-opener"
            target="_blank"
            href={`/api/orders/export/${order?.id}/`}
          >
            Export to Excel
          </a>
          <a
            class="btn btn-primary mb-2 me-2"
            rel="no-opener"
            target="_blank"
            href={`${HomePageURL}/invoices/?order=${order?.id}`}
          >
            Invoices
          </a>
          <a
            class="btn btn-primary mb-2 me-2"
            rel="no-opener"
            target="_blank"
            href={`${HomePageURL}/stock-transfers/?order=${order?.id}`}
          >
            Stock Moves
          </a>
        </div>
        <div className="col-xl-3 col-lg-3 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <div
              class="media"
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div
                class="w-img"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "40px",
                  backgroundColor: "#272660",
                }}
              >
                {order?.customer?.profile_pic_url ? (
                  <img
                    src={order?.customer?.profile_pic_url}
                    alt={order?.customer?.full_name}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "white",
                      fontWeight: "500",
                      fontSize: "40px",
                    }}
                  >
                    {order?.customer?.full_name[0]}
                  </span>
                )}
              </div>
              <div
                class="media-body"
                style={{ flexGrow: 1, paddingLeft: "10px" }}
              >
                <h6>{order?.customer?.full_name}</h6>
                <p class="meta-date-time">{order?.customer?.designation}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <h4>Order Value</h4>
            <span
              style={{ color: "#272660", fontSize: "1.3em", fontWeight: "700" }}
            >
              {formatCurrency(order?.amount_payable)}
            </span>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <h4>Fulfilling Branch</h4>
            <span
              style={{ color: "#272660", fontSize: "1.3em", fontWeight: "700" }}
            >
              {order?.branch_address?.first_name || "Select Branch"}
              <span
                role="button"
                style={{ display: "flex", height: "18px", width: "18px" }}
                title="Edit"
                onClick={() => setBranchSelectorShow(true)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-edit-2"
                >
                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                </svg>
              </span>
            </span>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <h4>Status</h4>
            <span
              style={{ color: "#272660", fontSize: "1.3em", fontWeight: "700" }}
            >
              {order?.status}
            </span>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <h4>Shipping Address</h4>
            <FullAddressWithName address={order?.shipping_address} />
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-sm-6  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <h4>Billing Address</h4>
            <FullAddressWithName
              address={order?.billing_address}
              includeGst={true}
            />
          </div>
        </div>
        <BranchSelector
          show={branchSelectorShow}
          setShow={setBranchSelectorShow}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
          onSave={handleSetBranch}
          multiselect={false}
        />
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <div className="table-responsive mb-4 mt-4">
              <table
                id="zero-config"
                className="table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="no-content"></th>
                    <th>Product</th>
                    <th>MRP</th>
                    <th>Quantity</th>
                    <th>Total</th>
                    <th>Discount(%)</th>
                    <th>Discounted Amount</th>
                    <th className="no-content"></th>
                  </tr>
                </thead>
                <tbody>
                  {order?.lineItems?.map((line) => {
                    return (
                      <OrderLine
                        key={line?.id}
                        line={line}
                        order={order}
                        setOrder={setOrder}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta })(OrderDetail);
